import { Component, HostBinding, Input } from '@angular/core';
import { ErrorInputs } from '@shared/services/error.service';
import { ButtonPadding, ButtonVariant } from '@app/components/button/button.component';
import { ZendeskService } from '@shared/services/zendesk.service';

@Component({
  selector: 'pl-error-display',
  templateUrl: './errorDisplay.component.html',
})
export class ErrorDisplayComponent {
  @Input() public error: ErrorInputs | null = null;

  protected readonly ButtonPadding: typeof ButtonPadding = ButtonPadding;
  protected readonly ButtonVariant: typeof ButtonVariant = ButtonVariant;

  @HostBinding('class') public classes: string = 'block grow';

  constructor(private zendeskService: ZendeskService) {}

  public refreshPage(): void {
    window.location.reload();
  }

  public openZendesk(): void {
    this.zendeskService.contactUs();
  }
}
